export const awsConfig = {
    Auth: {
        region: "us-east-1", // Replace with your AWS region
        userPoolId: "us-east-1_5Omn7uHSF", // Replace with your Cognito User Pool ID
        userPoolWebClientId: "tsb6fcjj219boqg9cfopvsf0a" // Replace with your Cognito App Client ID
    },
};